const addBookingReturn = (
	location,
	agentlogin,
	payment,
	payableAmout,
	priceDetails2,
	priceDetails3,
	selectedFlight,
	dispatch,
	FlightAddBookingDispatch,
	PGCharge,
	BookingFormData
) => {
	let etrav2 = location.state.selectedonward
		? location.state.selectedonward[0].Airline_Code &&
		  location.state.selectedReturn[0].Airline_Code
		: '';
	let etrvotbor = location.state.selectedonward
		? location.state.selectedonward[0].Airline_Code &&
		  location.state.selectedReturn[0].AirlineCode
		: '';
	let etravrtboo = location.state.selectedonward
		? location.state.selectedReturn[0].Airline_Code &&
		  location.state.selectedonward[0].AirlineCode
		: '';
	let tbo2 = location.state.selectedonward
		? location.state.selectedonward[0].AirlineCode &&
		  location.state.selectedReturn[0].AirlineCode
		: '';
	let formaddBooking = {
		orderId: location.state.orderID,
		supplier: `${location.state.selectedReturn[0].Supplier}|${location.state.selectedonward[0].Supplier}`,
		userEmail: location.state.formData.email,
		userPhone: location.state.formData.phone,
		user_type: agentlogin && agentlogin.status === 200 ? 'agent' : 'guest',
		origin: location.state.returnBody.Segments[0].Origin,
		destination: location.state.returnBody.Segments[0].Destination,
		travelDate: location.state.returnBody.Segments[0].PreferredDepartureTime,
		returnDate: location.state.returnBody.Segments[1].PreferredDepartureTime,
		journeyType: location.state.returnBody.JourneyType === 2 ? 'RoundTrip' : '',
		origin1: location.state.returnBody.Segments[1].Origin,
		destination1: location.state.returnBody.Segments[1].Destination,
		travelDate1: '',
		origin2: '',
		destination2: '',
		travelDate2: '',
		origin3: '',
		destination3: '',
		travelDate3: '',
		PGCharge:  0,
		class: 'Economy',
		nop: `${location.state.returnBody.AdultCount} | ${location.state.returnBody.ChildCount} | ${location.state.returnBody.InfantCount} `,
		airlineType: '',
		carrier: etrav2
			? `${location.state.selectedonward[0].Airline_Code}|${location.state.selectedReturn[0].Airline_Code}`
			:  tbo2
			? `${location.state.selectedonward[0].AirlineCode}|${location.state.selectedReturn[0].AirlineCode}`
			: '',
		fareType: 'R',
		eTicketType: 'eTicket',
		// actualFare:
		//   location.state.selectedReturn[0].Supplier === "TBO"
		//     ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fare.markup)) -
		//       Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
		//       Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
		//     : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fares.markup)) -
		//       Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
		//       Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
		markup: etrav2
			? Number(
					Number(Math.round(location.state.selectedonward[0].Fares.markup)) +
						Number(Math.round(location.state.selectedReturn[0].Fares.markup))
			  )
			: etravrtboo
			? Number(
					Number(Math.round(location.state.selectedonward[0].Fare.markup)) +
						Number(Math.round(location.state.selectedReturn[0].Fares.markup))
			  )
			: etrvotbor
			? Number(
					Number(Math.round(location.state.selectedonward[0].Fares.markup)) +
						Number(Math.round(location.state.selectedReturn[0].Fare.markup))
			  )
			: tbo2
			? Number(
					Number(Math.round(location.state.selectedonward[0].Fare.markup)) +
						Number(Math.round(location.state.selectedReturn[0].Fare.markup))
			  )
			: '',
		partnerMarkup: etrav2
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fares.partnerMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fares.partnerMarkup)
						)
			  )
			: etravrtboo
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fare.partnerMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fares.partnerMarkup)
						)
			  )
			: etrvotbor
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fares.partnerMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fare.partnerMarkup)
						)
			  )
			: tbo2
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fare.partnerMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fare.partnerMarkup)
						)
			  )
			: '',
		agentMarkup: etrav2
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fares.agentMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fares.agentMarkup)
						)
			  )
			: etravrtboo
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fare.agentMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fares.agentMarkup)
						)
			  )
			: etrvotbor
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fares.agentMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fare.agentMarkup)
						)
			  )
			: tbo2
			? Number(
					Number(
						Math.round(location.state.selectedonward[0].Fare.agentMarkup)
					) +
						Number(
							Math.round(location.state.selectedReturn[0].Fare.agentMarkup)
						)
			  )
			: '',
		// baseFare:
		//   location.state.OneflightData.Supplier === "TBO"
		//     ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fare.partnerMarkup)) -
		//       Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
		//     : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fares.partnerMarkup)) -
		//       Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
		// totalFare:
		//   location.state.OneflightData.Supplier === "TBO"
		//     ? Number(Math.round(location.state.OneflightData.Fare.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fare.agentMarkup))
		//     : Number(Math.round(location.state.OneflightData.Fares.Total_Amount)) -
		//       Number(Math.round(location.state.OneflightData.Fares.agentMarkup)),
		payableAmount: payableAmout,
		ticketCost: Number(payableAmout),
		totalEarn: 0,
		cashBack: '0.00',
		couponDiscount: 0.0,
		couponDetails: '',
		pricingDetails: etrav2
			? priceDetails2
			: etrvotbor
			? [priceDetails2, priceDetails3]
			: etravrtboo
			? [priceDetails2, priceDetails3]
			: '',
		selectedFlight: [
			location.state.selectedonward[0],
			location.state.selectedReturn[0],
		],
		airlineType: '',
		selectedPax: BookingFormData,
		ticketSent: 0,
		paymentMode: agentlogin
			? payment === 'offline'
				? 'OFFLINE'
				: 'ONLINE'
			: 'ONLINE',
		agent_id:
			agentlogin && agentlogin.status === 200
				? agentlogin && agentlogin.result.result.id
				: 0,
	};
	dispatch(FlightAddBookingDispatch(formaddBooking, payment));
	console.log('add booking', formaddBooking);
};
export default addBookingReturn;
